import React, { useState } from 'react';
import { Form, Input, Modal } from 'antd';
import { t } from 'helpers/i18n';

export interface AddConfigParamProps {
  existingKeys: string[];
  handleCloseModal: (newKey?: string, value?: string) => void;
}

const AddConfigParamPopup: React.FC<AddConfigParamProps> = (props) => {
  const [error, setError] = useState<string>('');
  const [key, setKey] = useState('');
  const [value, setValue] = useState('');
  const { handleCloseModal, existingKeys } = props;

  const onSaveUser = async () => {
    if (!key) {
      setError(t('create_project_remote_config_table_empty_key'));
      return;
    }

    if (error) return;

    handleCloseModal(key, value);
  };

  const onKeyTextChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newKey = event.target.value;

    if (!newKey) {
      setError(t('create_project_remote_config_table_empty_key'));
      return;
    }

    if (existingKeys.includes(newKey)) {
      setError(t('create_project_remote_config_table_existing_key'));
      return;
    }

    setError('');
    setKey(newKey);
  };

  const onValueTextChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
  };

  return (
    <Modal
      visible={true}
      title={t('create_project_remote_config_table_new_config')}
      onCancel={() => {
        handleCloseModal();
      }}
      centered={true}
      onOk={onSaveUser}
    >
      <Form.Item validateStatus={error ? 'error' : 'success'} help={error}>
        <Input
          placeholder={t('create_project_remote_config_table_enter_key')}
          status={error ? 'error' : ''}
          onChange={onKeyTextChanged}
          size="large"
        />
      </Form.Item>

      <Form.Item>
        <Input
          placeholder={t('create_project_remote_config_table_enter_value')}
          onChange={onValueTextChanged}
          size="large"
        />
      </Form.Item>
    </Modal>
  );
};

export default AddConfigParamPopup;
